import { Row } from 'antd';
import React from 'react';
import styled from 'styled-components';

const MessageWrapper = styled.div`
  & .notification {
    position: relative; // added this to position the now text relative to notification
    background-color: #f5f5f5;
    border-radius: 16px;
    padding: 10px;
    margin-top: 20px;
    display: flex;
    justify-content: left;
    align-items: center;
    min-width: 300px;
  }

  & .notification-now {
    position: absolute;
    top: 10px;
    right: 10px; // Position the "now" at the right top
    font-size: 14px;

    & .now-text {
      display: block; // By default the text is visible
    }

    & .now-icon {
      display: none; // By default the icon is hidden
    }
  }

  & .notification-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 1px;
    align-self: flex-start;
    margin-right: 20px;
  }

  /* Notification title */
  .notification-title {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 4px;
  }

  /* Notification message */
  .notification-message {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 10px;
    max-width: 200px;
  }

  & .notification-icon {
    width: 40px;
    height: 40px;
    object-fit: contain;
    margin-left: auto;
    margin-top: 20px;
  }

  & .notification-chrome-icon-container {
    background: #fff;
    margin-right: 10px; // Add some space to the right of the icon
    border-radius: 8px;
  }
  & .notification-chrome-icon {
    width: 36px;
    height: 36px;
    align-self: center; // Vertically center the icon
  }
`;

export const WebPushPreview = (props: {
  title?: string;
  message?: string;
  icon?: string;
  url?: string;
  time?: string;
  disableClick?: boolean;
}): JSX.Element => {
  return (
    <Row justify="center">
      <MessageWrapper>
        <div
          className="notification"
          style={{
            cursor:
              props.disableClick === undefined || props.disableClick === true
                ? 'default'
                : 'pointer'
          }}
          onClick={() => {
            if (props.url && props.disableClick === undefined) {
              window.open(props.url, '_blank');
            }
          }}
        >
          <div className="notification-now">
            <span className="now-text" style={{ color: '#999' }}>
              {props.time}
            </span>
          </div>
          <div className="notification-chrome-icon-container">
            <img
              className="notification-chrome-icon"
              src={window.origin + '/img/87865_chrome_icon.png'}
              alt="Chrome icon"
            />
          </div>
          <div className="notification-content">
            <div className="notification-title">{props.title}</div>
            <div className="notification-message">
              {props.message?.length && props.message.length > 100
                ? `${props.message.substring(0, 50)}...`
                : props.message}
            </div>
          </div>
          {props.icon && (
            <img
              className="notification-icon"
              src={props.icon}
              alt="Company Icon"
            />
          )}
        </div>
      </MessageWrapper>
    </Row>
  );
};
